import React from "react";
import styles from "./Toggle.module.scss";
import classNames from "classnames";

export default ({ value, toggle, className, disabled, Component = "button", pending, children, style}) => {
    let circleFill = value ? "#006DC9" : "#F5F5F5";
    if(disabled) {
        circleFill = value ? "#93b3e5" : "#c8c8c8"
    }
    const circleTransform = value ? "translate(17)" : "translate(0)";
    const shadowOpacity = value ? 0 : 1;
    let railOpacity = value ? 0.8 : 1;
    if(disabled && value) {
        railOpacity = 0.8;
    }
    let railFill = value ? "#93B3E5" : "#C8C8C8";
    if(disabled) {
        railFill = value ? "#93b3e5" : "#e0e0e0";
    }

    let pendingStroke = "none";
    if(pending) {
        pendingStroke = value ? "#fff" : "#c8c8c8";
    }

    return (
        <Component style={style} className={classNames(styles['toggle'], className, {[styles['pending']]: pending, [styles['disabled']]: disabled})} disabled={pending || disabled} onClick={() => !disabled && toggle(!value)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="19" viewBox="0 0 36 19" overflow="visible">
                <defs>
                    <filter id="prefix__a" width="172.2%" height="172.2%" x="-30.6%" y="-30.6%" filterUnits="objectBoundingBox">
                        <feOffset dx="1" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"/>
                        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"/>
                        <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"/>
                    </filter>
                </defs>
                <g fill="none">
                    <path className={styles['toggle-transition']} fill={railFill} opacity={railOpacity} d="M6.782 3.5h22.436c3.39-.076 6.202 2.61 6.282 6-.08 3.39-2.891 6.076-6.282 6H6.782C3.392 15.576.58 12.89.5 9.5c.08-3.39 2.891-6.076 6.282-6z"/>
                    <circle className={styles['toggle-transition']} transform={circleTransform} opacity={shadowOpacity} fill="#000" cx="9.5" cy="9.5" r="9" filter="url(#prefix__a)"/>
                    <circle className={styles['toggle-transition']} fill={circleFill} transform={circleTransform} cx="9.5" cy="9.5" r="9"/>
                </g>
                {pending && <circle className={classNames(styles['pending-circle'], styles['toggle-transition'])} cx={value ? "26.5" : "9.5"} style={{transformOrigin: value ? "26.5px center" : "9.5px center"}} cy="9.5" r="5" stroke={pendingStroke} strokeWidth="1" fill="none"/>}
            </svg>
            {children && <span>{children}</span>}
        </Component>
    );
};
